import { h } from "preact";

import { classNames } from "../helpers";

export default function CircleLoadingIndicator(props) {
  if (props.dark) {
    return (
      <img src="/images/spinner-dark.svg" class={classNames(props.class)} />
    );
  }
  return <img src="/images/spinner.svg" class={classNames(props.class)} />;
}
